// Send Logs on screen (docs/features/send-logs.md › Web app): the ⋯ sheet's row — **Send Logs** (one per Mac, "Send
// Logs to <Mac>", when there are several) with its one line under it — and the ask card, a small glass panel near the
// top when a Mac asks: "Mac asked for logs" · Send / Not now. Plain DOM made here; index.html is not touched. Its
// controls are full 44 px targets on a touch screen and its text reads at 13 px or more (design/tokens.json › screen).
import { SCREEN } from '../core/tokens.js'

const STYLE = `
#sendlogs-row { margin: 10px 0 4px; padding-top: 10px; border-top: 1px solid var(--line); }
#sendlogs-row[hidden], #sendlogs-ask[hidden] { display: none; }
#sendlogs-row .link { min-height: ${SCREEN.minTarget}px; }
#sendlogs-row .n { margin: 0 0 6px; font-size: 13px; color: var(--dim); }
#sendlogs-ask { position: fixed; z-index: 61; top: calc(64px + env(safe-area-inset-top, 0px)); left: 50%; transform: translateX(-50%);
  width: max-content; max-width: min(420px, calc(100vw - 32px)); box-sizing: border-box; padding: 14px 16px 12px; border-radius: 22px;
  background: var(--c-card); -webkit-backdrop-filter: blur(24px) saturate(1.4); backdrop-filter: blur(24px) saturate(1.4);
  color: var(--c-ink); box-shadow: 0 10px 30px rgb(var(--c-shade-rgb) / calc(0.22 * var(--c-shade-k))); font: 15px/1.35 -apple-system, "SF Pro Text", system-ui, sans-serif; }
#sendlogs-ask .t { margin: 0; font-weight: 600; }
#sendlogs-ask .n { margin: 6px 0 0; font-size: 14px; color: rgb(var(--c-ink-rgb) / 0.84); }
#sendlogs-ask .b { display: flex; justify-content: flex-end; gap: 8px; margin-top: 12px; }
#sendlogs-ask .btn { appearance: none; border: 0; color: var(--c-ink); font-family: inherit; cursor: pointer; min-height: ${SCREEN.minTarget}px; min-width: ${SCREEN.minTarget}px; border-radius: 22px; font-size: 15px; }
#sendlogs-ask .btn.prominent { background: var(--screen-prominent); color: var(--c-on-accent); }   /* design/tokens.json › screen.prominent: white on it at 4.5:1 */
#sendlogs-ask :focus-visible { outline: 3px solid var(--focus-on-glass); outline-offset: 2px; }
`

let made = null
function make() {
  if (made) return made
  const style = document.createElement('style')
  style.textContent = STYLE
  document.head.appendChild(style)
  const row = document.createElement('div')
  row.id = 'sendlogs-row'
  row.hidden = true
  document.getElementById('sheet')?.insertBefore(row, document.getElementById('build'))
  const card = document.createElement('div')
  card.id = 'sendlogs-ask'
  card.hidden = true
  card.setAttribute('role', 'dialog')
  card.setAttribute('aria-live', 'polite')
  card.setAttribute('aria-label', 'Logs asked for')
  document.body.appendChild(card)
  made = { row, card }
  return made
}

function node(tag, className, text) {
  const n = document.createElement(tag)
  if (className) n.className = className
  if (text != null) n.textContent = text
  return n
}

/// The ⋯ sheet's row. `model`: { rows: [{ key, label, line }], phoneLine } (no rows: hidden); `onSend(key)`.
export function drawRow(model, onSend) {
  const { row } = make()
  const rows = model?.rows || []
  row.hidden = !rows.length
  row.replaceChildren()
  for (const r of rows) {
    const button = node('button', 'link', r.label)
    button.type = 'button'
    button.dataset.mac = r.key
    button.onclick = () => onSend(r.key)
    row.appendChild(button)
    if (r.line) row.appendChild(node('p', 'n', r.line))
  }
  if (model?.phoneLine) row.appendChild(node('p', 'n', model.phoneLine))
}

/// The ask card: `ask` { title, note } or null (hidden). `on.send()`, `on.later()`.
export function drawAsk(ask, on) {
  const { card } = make()
  card.hidden = !ask
  card.replaceChildren()
  if (!ask) return
  card.appendChild(node('p', 't', ask.title))
  if (ask.note) card.appendChild(node('p', 'n', ask.note))
  const bar = node('div', 'b')
  const later = node('button', 'btn small bordered', 'Not now')
  const send = node('button', 'btn small prominent', 'Send')
  later.type = send.type = 'button'
  later.onclick = () => on.later()
  send.onclick = () => on.send()
  bar.append(later, send)
  card.appendChild(bar)
}
